import { render, staticRenderFns } from "./flip-cards-game.vue?vue&type=template&id=00c43fa8&scoped=true&"
import script from "./flip-cards-game.vue?vue&type=script&lang=js&"
export * from "./flip-cards-game.vue?vue&type=script&lang=js&"
import style0 from "./flip-cards-game.vue?vue&type=style&index=0&id=00c43fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c43fa8",
  null
  
)

export default component.exports